/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityInfraDashboardBaseFilters {
    getFixupPrototypeFunction() { return SecurityInfraDashboardBaseFilters.fixupPrototype; }

    static newInstance(model: Partial<SecurityInfraDashboardBaseFilters>): SecurityInfraDashboardBaseFilters {
        let obj = Object.assign(new SecurityInfraDashboardBaseFilters(), model);
        SecurityInfraDashboardBaseFilters.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityInfraDashboardBaseFilters>): SecurityInfraDashboardBaseFilters {
        if (!model) return null;
        return SecurityInfraDashboardBaseFilters.newInstance(<SecurityInfraDashboardBaseFilters> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityInfraDashboardBaseFilters) {
        if (!obj) return;

        models.SecurityInfraDashboardBaseFilters.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityInfraDashboardBaseFilters): boolean {
        Object.setPrototypeOf(obj, SecurityInfraDashboardBaseFilters.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.filters) {
            models.QueryOperator.fixupPrototype(this.filters);
        }
    }

    /**
     * List of Tenant IDs to filter the threats/vulnerabilities. This can be fetched from the List Tenants API call.
     */
    tenant_ids: Array<string>;

    /**
     * Query based on Cloud Providers, Cloud Account Ids, Statuses, Severities, ResourceCategories, ResourceTypes, Resources, Resource ID(s)
     */
    filters: models.QueryOperator;

}
